import {useEffect} from 'react';
import {Form, Select, Spin} from 'antd';
import {
  Button,
  CommonInput,
} from '@/components/common-components/components';
import styles from './style.module.scss';

import {useState} from 'react';
import {languages} from '@/components/dashboard/pages/content-ideas/drawer/languages';
import Flag from '@/components/common-components/components/flag';
import {formatCountryCode} from '@/components/dashboard/pages/content-ideas/drawer/languageUtil';
import {ContentIdeasStore} from '@/store/content-optimizer/contentIdeas';
import {observer} from 'mobx-react';
import {LoadingOutlined} from '@ant-design/icons';

import {MixPanel} from '@/utils/mixpanel';
import {SCA_PAGE_CONTENT_IDEAS_GENERATE} from '@/constants/events';
import {useStore} from '@/store/root-store';

interface Props {
  store: ContentIdeasStore;
  pageId: any;
  drawerVisible: boolean;
}

export const NewContentIdeaForm = observer(({store, pageId, drawerVisible}: Props) => {
  const {
    settings: {
      customer: {
        getCustomerQuota,
      },
    },
  } = useStore('');


  const usaCode = languages.find(lang => lang.code == 'en');


  const antIcon = <LoadingOutlined style={{fontSize: 24, marginLeft: '10px', color: '#7f4ead', marginTop: '5px'}} spin />;

  const [selectedCountry, setSelectedCountry] = useState(usaCode.code);

  const onChange = value => {
    setSelectedCountry(value);
  };

  const [form] = Form.useForm();
  const {Option} = Select;

  useEffect(() => {
    if (!drawerVisible) form.resetFields();
  }, [drawerVisible]);

  const onFormSubmit = async (values: {[key: string]: string}) => {
    const topic = values.topic;

    await store.loadContentIdeasData(topic, selectedCountry);

    getCustomerQuota();

    MixPanel.track(SCA_PAGE_CONTENT_IDEAS_GENERATE, {
      'pageId': pageId,
      'contentIdeasTopic': topic,
      'contentIdeasLanguage': languages.find(lang => lang.code == selectedCountry).language,
      'description': 'Generated content ideas for specific topic and language',
    });
  };

  return (
    <>
      <p className={styles.descriptionText}>Need some inspiration? Here you can generate unlimited article ideas on any topic you can think of.</p>

      <Form form={form} onFinish={onFormSubmit}>
        <div>
          <p className={styles.inputLabel}>Topic</p>
          <Form.Item name='topic' rules={[{required: true, message: 'Please add at least one keyword'}]}>
            <CommonInput
              type='text'
              variant='light'
              placeholder='e.g Digital marketing in New York'
              className={styles.input} />
          </Form.Item>
        </div>
        <div style={{display: 'flex'}}>
          <div className={styles.countrySelector}>
            <Select
              showSearch
              className={styles.selectInput}
              value={selectedCountry}
              onChange={onChange}
              filterOption={(input, option) =>
                option.country.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {
                languages.map((lang, index) => {
                  return (
                    <Option disabled={false} key={index} country={lang.language} value={lang.code}>
                      <Flag width={12} code={formatCountryCode(lang.language, lang.code)} style={{marginRight: '5px'}}></Flag>
                      {lang.language}
                    </Option>
                  );
                })
              }
            </Select>
          </div>
          {/* </Form.Item> */}
          <Button type='submit' buttonType='purple' className={styles.generateIdeasButton}>Generate Ideas</Button>
          {store.loading ? <Spin indicator={antIcon} /> : null}
        </div>
      </Form>
    </>
  );
});
